import React from "react";
import "./../HairSubService.css"

const DandruffTreatmentTestimonial = () => {
  return (
    <div className="hairSubServiceCustomer">
      <h5>Why Bangaloreans Trust SCENT for Dandruff Treatment</h5>
      <p>
        Clients across Bangalore choose SCENT for our expertise, personalized
        care, and commitment to excellence. Here’s what some of our happy
        clients have to say:
      </p>
      <div className="hairSubServiceCustomerContent">
        <p>
          <span className="quote">“</span>SCENT’s dandruff treatment in
          Bangalore transformed my scalp health. The flaking and itching are
          gone, and my hair feels amazing!
          <span className="quote">”</span> - <span>Priya </span>
        </p>
        <p>
          <span className="quote">“</span>The team at SCENT is highly
          professional and knowledgeable. Their customized approach worked
          wonders for my dandruff issue.
          <span className="quote">”</span> - <span> Arjun </span>
        </p>
        <p>
          <span className="quote">“</span>I’ve tried multiple dandruff
          solutions, but SCENT’s treatment gave me the best results. Highly
          recommended!
          <span className="quote">”</span> - <span> Sneha </span>
        </p>
      </div>
    </div>
  );
};

export default DandruffTreatmentTestimonial;
